import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=43157a84&scoped=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=43157a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43157a84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43157a84')) {
      api.createRecord('43157a84', component.options)
    } else {
      api.reload('43157a84', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=43157a84&scoped=true&", function () {
      api.rerender('43157a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/layout/Breadcrumbs.vue"
export default component.exports